import { useCookie } from "@/composables";

export const AuthorizedGuard = () => {
  const tokenStorage = useCookie("tms_token");
  if (tokenStorage.get() === null) {
    return { name: "login" };
  }
  return true;
};
